module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/baskerville_light-ff677a5c3a188fcee49e4451afc3a768.woff";